import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPopcorn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M5.37,8.13h0a3.13,3.13,0,0,1,4.42,0h0a3.12,3.12,0,0,1,4.41,0h0a3.13,3.13,0,0,1,4.42,0h0L17.53,22.5H6.47Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M6.82,7.31A2.32,2.32,0,0,1,6.27,5.8,2.39,2.39,0,0,1,8.66,3.41a2.31,2.31,0,0,1,1,.22,2.37,2.37,0,0,1,4.72,0,2.31,2.31,0,0,1,1-.22A2.39,2.39,0,0,1,17.73,5.8a2.32,2.32,0,0,1-.55,1.51"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 10.09,
			y: 14.86,
			width: 3.82,
			height: .95
		})
	]
});
const ForwardRef = forwardRef(SvgPopcorn);
export default ForwardRef;
